import { useEffect, useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { registerServiceWorker } from "@/shared/lib/pwa";

// Registers the service worker and shows a banner when a new version is ready.
// Clicking Uppdatera activates the waiting worker, which reloads the page.
export function PwaUpdatePrompt() {
  const [activate, setActivate] = useState<(() => void) | null>(null);

  useEffect(() => {
    registerServiceWorker((doActivate) => setActivate(() => doActivate));
  }, []);

  if (!activate) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 flex justify-center p-4">
      <div className="flex items-center gap-3 rounded-lg border border-border bg-card px-4 py-3 text-card-foreground shadow-lg">
        <span className="text-sm">Ny version tillgänglig.</span>
        <Button size="sm" onClick={() => activate()}>
          Uppdatera
        </Button>
      </div>
    </div>
  );
}
